(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geometric-pattern-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function buildAndApplyPattern(canvas) {
      var primary = canvas.dataset.colorPrimary || '#2B4D3D';
      var accent  = canvas.dataset.colorAccent  || '#B8CCA8';
      var cell    = parseInt(canvas.dataset.cellSize, 10) || 80;
      var tile    = cell * 2;
      var r       = cell / 2;

      /* Build a 2×2-cell SVG tile:
         ┌────────┬────────┐
         │ accent │primary │  ← dark circle on accent bg | light circle on primary bg
         │  ●dark │light●  │
         ├────────┼────────┤
         │primary │ accent │  ← light circle on primary bg | dark circle on accent bg
         │light●  │  ●dark │
         └────────┴────────┘
      */
      var svg = [
        '<svg xmlns="http://www.w3.org/2000/svg"',
        ' width="' + tile + '" height="' + tile + '">',
        '<rect width="' + tile + '" height="' + tile + '" fill="' + accent + '"/>',
        '<rect x="' + cell + '" y="0" width="' + cell + '" height="' + cell + '" fill="' + primary + '"/>',
        '<rect x="0" y="' + cell + '" width="' + cell + '" height="' + cell + '" fill="' + primary + '"/>',
        '<circle cx="' + r + '" cy="' + r + '" r="' + r + '" fill="' + primary + '"/>',
        '<circle cx="' + (cell + r) + '" cy="' + r + '" r="' + r + '" fill="' + accent + '"/>',
        '<circle cx="' + r + '" cy="' + (cell + r) + '" r="' + r + '" fill="' + accent + '"/>',
        '<circle cx="' + (cell + r) + '" cy="' + (cell + r) + '" r="' + r + '" fill="' + primary + '"/>',
        '</svg>'
      ].join('');

      canvas.style.backgroundImage  = 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';
      canvas.style.backgroundRepeat = 'repeat';
      canvas.style.backgroundSize   = tile + 'px ' + tile + 'px';
      canvas.style.backgroundColor  = 'transparent';
    }

    function init(root) {
      var canvas = root.querySelector
        ? root.querySelector('.geometric-pattern-band__canvas')
        : null;
      if (canvas) buildAndApplyPattern(canvas);
    }

    /* Initial render */
    document.querySelectorAll('[data-section-type="geometric-pattern-band"]').forEach(init);

    /* Theme-editor live updates */
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector('.geometric-pattern-band__canvas')) {
        init(event.target);
      }
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-cocktail-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCocktailDetail(sectionId) {
      var root = document.getElementById('kc-cocktail-detail-' + sectionId);
      if (!root) return;

      // ── Share popover links ──
      var shareWrap = root.querySelector('[data-share-wrap]');
      var sharePopover = root.querySelector('[data-share-popover]');

      if (shareWrap && sharePopover) {
        shareWrap.addEventListener('mouseenter', function () {
          sharePopover.style.display = 'block';
        });
        shareWrap.addEventListener('mouseleave', function () {
          sharePopover.style.display = 'none';
        });
        shareWrap.addEventListener('focusin', function () {
          sharePopover.style.display = 'block';
        });
        shareWrap.addEventListener('focusout', function (e) {
          if (!shareWrap.contains(e.relatedTarget)) sharePopover.style.display = 'none';
        });

        sharePopover.querySelectorAll('[data-share-network]').forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            var url = encodeURIComponent(window.location.href);
            var title = encodeURIComponent(document.title);
            var network = link.getAttribute('data-share-network');
            var shareUrl = '';
            if (network === 'facebook') {
              shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
            } else if (network === 'pinterest') {
              shareUrl = 'https://pinterest.com/pin/create/button/?url=' + url + '&description=' + title;
            }
            if (shareUrl) window.open(shareUrl, '_blank', 'width=600,height=400,noopener,noreferrer');
            sharePopover.style.display = 'none';
          });
        });
      }

      // ── Print button ──
      var printBtn = root.querySelector('[data-cocktail-print]');
      if (printBtn) {
        printBtn.addEventListener('click', function () {
          printRecipe();
        });
      }
    }

    window.printRecipe = function printRecipe() {
      var printTemplate = document.getElementById('recipe-print-template');
      if (!printTemplate) {
        console.error('Print template not found');
        return;
      }

      var recipeTitle =
        document.querySelector('.recipe-header h1')?.textContent ||
        document.querySelector('h1')?.textContent ||
        'Recipe';

      var printWindow = window.open('', '_blank', 'width=800,height=600');

      var printContent = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Print Recipe - ${recipeTitle}</title>
          <style>
            body {
              font-family: Georgia, 'Times New Roman', serif;
              line-height: 1.4;
              color: #333;
              max-width: 800px;
              margin: 0 auto;
              padding: 30px;
              background: white;
            }
            .recipe-print-header {
              text-align: left;
              margin-bottom: 30px;
            }
            .recipe-category {
              font-size: 12px;
              font-weight: bold;
              letter-spacing: 2px;
              color: #666;
              margin-bottom: 10px;
            }
            .recipe-title {
              font-family: 'Times New Roman', serif;
              font-size: 48px;
              font-weight: normal;
              color: #000;
              margin: 0 0 20px 0;
              line-height: 1.1;
            }
            .recipe-description {
              font-size: 16px;
              line-height: 1.5;
              color: #333;
              margin-bottom: 30px;
              font-weight: normal;
            }
            .recipe-meta {
              display: flex;
              gap: 30px;
              margin-bottom: 40px;
              padding-bottom: 20px;
              border-bottom: 1px solid #ddd;
            }
            .meta-item {
              display: flex;
              align-items: center;
              gap: 8px;
            }
            .meta-icon { font-size: 18px; }
            .meta-content { display: flex; flex-direction: column; }
            .meta-label {
              font-size: 10px;
              font-weight: bold;
              letter-spacing: 1px;
              color: #666;
              text-transform: uppercase;
            }
            .meta-value {
              font-size: 14px;
              font-weight: bold;
              color: #000;
              text-transform: uppercase;
            }
            .ingredients-section, .instructions-section {
              margin-bottom: 40px;
            }
            .ingredients-section h2, .instructions-section h2 {
              font-family: 'Times New Roman', serif;
              font-size: 24px;
              font-weight: normal;
              color: #000;
              margin: 0 0 20px 0;
              text-transform: uppercase;
              letter-spacing: 1px;
            }
            .ingredients-section ul {
              list-style: none;
              padding-left: 0;
              margin: 0;
            }
            .ingredients-section ul li {
              margin-bottom: 8px;
              padding-left: 20px;
              position: relative;
              font-size: 14px;
              line-height: 1.4;
            }
            .ingredients-section ul li::before {
              content: "\u2022";
              color: #000;
              font-weight: bold;
              position: absolute;
              left: 0;
            }
            .instructions-section div,
            .instructions-section p {
              font-size: 14px;
              line-height: 1.6;
              margin-bottom: 15px;
            }
            .instructions-section ol {
              padding-left: 20px;
              margin: 0;
            }
            .instructions-section ol li {
              margin-bottom: 15px;
              font-size: 14px;
              line-height: 1.6;
            }
            @media print {
              body { padding: 20px; }
              .no-print { display: none !important; }
              .recipe-title { font-size: 36px; }
              .meta-item { break-inside: avoid; }
            }
          </style>
        </head>
        <body>
          ${printTemplate.innerHTML}
        </body>
        </html>
      `;

      printWindow.document.open();
      printWindow.document.write(printContent);
      printWindow.document.close();

      printWindow.onload = function () {
        printWindow.focus();
        printWindow.print();
        printWindow.onafterprint = function () {
          printWindow.close();
        };
      };
    }

    // Shopify {% javascript %} runs after DOM is ready — no DOMContentLoaded needed.
    initCocktailDetail('{{ section_id }}');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.kc-hero-section a.hover_rotate').forEach(function(btn) {
    btn.addEventListener('mouseenter', function() {
      btn.setAttribute('data-interacted', '');
    }, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-image-with-text"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.kc-iwt-section a.hover_rotate').forEach(function(btn) {
    btn.addEventListener('mouseenter', function() {
      btn.setAttribute('data-interacted', '');
    }, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
